import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Auth, AuthState, User } from '../types/auth';

const initialState: AuthState = {
  user: null,
  auth: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData(state, action: PayloadAction<{ user: User; auth: Auth;}>) {
      state.user = action.payload.user;
      state.auth = action.payload.auth;
    },
    clearAuthData(state) {
      state.user = null;
      state.auth = null;
    },

  },
});

export const { setAuthData, clearAuthData } = authSlice.actions;
export default authSlice.reducer;
